const hostnameToApiEndPoint = {
    'athanase2000.audeladespixels.com': 'https://behhh.audeladespixels.com/',
    'behhh-pwa.audeladespixels.com': 'https://behhh-test.audeladespixels.com/',
    'pol.audeladespixels.com': 'https://pol-admin.audeladespixels.com/',
    'localhost': 'http://127.0.0.1:8000/',
    '127.0.0.1': 'http://127.0.0.1:8000/',
    '0.0.0.0': 'http://127.0.0.1:8000/',
    '192.168.0.3': 'http://127.0.0.1:8000/',
}

export const apiEndPoint = hostnameToApiEndPoint[location.hostname];